import { StyleSheet } from 'aphrodite';
import { brandPrimaryText } from '../../../styles/colors';

export const s = StyleSheet.create({
	button: {
		alignItems: 'center',
		color: brandPrimaryText,
		display: 'flex',
		fontSize: 12,
		gap: 8,
	},
	container: {
		boxSizing: 'border-box',
	},
});
